var React = require('react');

function Institution (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.25 9h19.5L12 3 2.25 9ZM5.25 9v7.5M9.75 9v7.5M14.252 9v7.5M18.75 9v7.5M3 16.5h18M1.502 19.5h21","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Institution.defaultProps = {"viewBox":"0 0 24 24","fill":"none","strokeWidth":"2.002"};

module.exports = Institution;

Institution.default = Institution;
